import { render, staticRenderFns } from "./fliptile.vue?vue&type=template&id=5ccba0ae&scoped=true&"
import script from "./fliptile.vue?vue&type=script&lang=js&"
export * from "./fliptile.vue?vue&type=script&lang=js&"
import style0 from "./fliptile.vue?vue&type=style&index=0&id=5ccba0ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccba0ae",
  null
  
)

export default component.exports